// prettier-ignore
export const contactFormData = [
  {
    name: 'João Silva',
    email: 'joao.silva@example.com',
    phone: '(11) 98765-4321',
    subject: 'Consulta sobre apartamento',
    message: 'Gostaria de agendar uma visita para ver o apartamento de 2 quartos no centro. Quando estaria disponível?'
  },
  {
    name: 'Maria Oliveira',
    email: 'maria.oliveira@example.com',
    phone: '(21) 99876-5432',
    subject: 'Interesse em casa na praia',
    message: 'Tenho interesse na casa à venda em Copacabana. Poderia me enviar mais detalhes e fotos?'
  },
  {
    name: 'Carlos Souza',
    email: 'carlos.souza@example.com',
    phone: '(31) 98765-1234',
    subject: 'Aluguel de sala comercial',
    message: 'Estou procurando uma sala comercial para alugar no bairro Savassi. Vocês têm opções disponíveis?'
  },
  {
    name: 'Ana Costa',
    email: 'ana.costa@example.com',
    phone: '(41) 99876-1234',
    subject: 'Consulta sobre financiamento',
    message: 'Gostaria de saber se vocês trabalham com financiamento para a compra de imóveis. Qual é a taxa de juros?'
  },
  {
    name: 'Pedro Santos',
    email: 'pedro.santos@example.com',
    phone: '(51) 98765-6789',
    subject: 'Visita a terreno',
    message: 'Tenho interesse no terreno à venda no bairro Jardins. Podemos agendar uma visita para esta semana?'
  },
  {
    name: 'Fernanda Lima',
    email: 'fernanda.lima@example.com',
    phone: '(61) 99876-5678',
    subject: 'Consulta sobre condomínio',
    message: 'Gostaria de saber mais sobre o condomínio fechado que vocês estão anunciando. Qual é o valor do condomínio?'
  },
  {
    name: 'Ricardo Almeida',
    email: 'ricardo.almeida@example.com',
    phone: '(71) 98765-9876',
    subject: 'Interesse em apartamento',
    message: 'Vi o anúncio de um apartamento de 3 quartos no bairro Barra. Poderia me enviar mais informações?'
  },
  {
    name: 'Juliana Pereira',
    email: 'juliana.pereira@example.com',
    phone: '(81) 99876-4321',
    subject: 'Consulta sobre imóvel rural',
    message: 'Estou interessado em uma propriedade rural. Vocês têm opções disponíveis na região de Petrolina?'
  },
  {
    name: 'Lucas Rocha',
    email: 'lucas.rocha@example.com',
    phone: '(85) 98765-3456',
    subject: 'Aluguel de apartamento',
    message: 'Preciso alugar um apartamento de 1 quarto no bairro Aldeota. Vocês têm alguma opção disponível?'
  },
  {
    name: 'Patrícia Gomes',
    email: 'patricia.gomes@example.com',
    phone: '(91) 99876-6543',
    subject: 'Consulta sobre imóvel comercial',
    message: 'Gostaria de saber mais sobre o imóvel comercial à venda no centro de Belém. Qual é o valor do aluguel?'
  }
];
